import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useUser } from "../hooks/Authorize";

const useFilteredItems = ({ baseFilters = {}, monitorParams = [] }) => {
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();
  const [clikkleItems, setClikkleItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const lastFilterRef = useRef(null);

  const getMonitoredQuery = () => {
    const urlParams = new URLSearchParams(location.search);
    const monitored = {};
    monitorParams.forEach((key) => {
      const val = urlParams.get(key);
      if (val !== null) monitored[key] = val;
    });
    return monitored;
  };

  const effectiveFilters = {
    ...baseFilters,
    ...getMonitoredQuery(),
    ownerId: platformUser._id,
  };

  useEffect(() => {
    const currentFiltersString = JSON.stringify(effectiveFilters);

    // Skip fetching only if filters are 100% identical
    if (lastFilterRef.current === currentFiltersString) return;

    lastFilterRef.current = currentFiltersString; // update ref

    const fetchItems = async () => {
      setLoading(true);
      try {
        const apiParams = new URLSearchParams();

        Object.entries(effectiveFilters).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            apiParams.set(key, value);
          }
        });

        const response = await axios.get(
          `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs?${apiParams.toString()}`
        );

        setClikkleItems(response.data);
        console.log(response.data);
      } catch (err) {
        console.error("Failed to fetch items:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, JSON.stringify(baseFilters), platformUser._id]);

  return { clikkleItems, setClikkleItems, loading };
};

export default useFilteredItems;
